import type { CartButtonDisplayStatus } from '~~/common/config/CartButtonDisplayStatus';
import { CBDS_MODIFICATION_STRATEGY_DISALLOWS_CART_OPERATIONS, CBDS_NOT_AVAILABLE_ADULT_DELIVERY_MODE, CBDS_NOT_AVAILABLE_DURING_ORDER_MODIFICATION, CBDS_NOT_AVAILABLE_IN_COLD_PARCEL, CBDS_NOT_AVAILABLE_OFFLINE_PRODUCT, CBDS_NOT_AVAILABLE_ONLINE, CBDS_UNAVAILABLE, CBDS_UNDECIDABLE } from '~~/common/config/CartButtonDisplayStatus';

type CartButtonDisplayStatusUiNotificationItem = {
  type: 'info' | 'warning';
  iconName: 'education-16' | 'maintenence-16';
  text: {
    title?: '';
    titleToken?: string;
    subtitle?: '';
    subtitleToken?: string;
  },
};

class CartButtonDisplayStatusUi {
  public shortText: string;
  public shorterText: string;
  public notificationItem: CartButtonDisplayStatusUiNotificationItem & { manualClose: false };

  constructor (arg: {
    shortText: string,
    shorterText?: string,
    notificationItem: CartButtonDisplayStatusUiNotificationItem,
  }) {
    this.shortText = arg.shortText;
    this.shorterText = arg.shorterText || arg.shortText;
    this.notificationItem = {
      ...arg.notificationItem,
      manualClose: false,
    };
  }
}

export const cartButtonDisplayStatusUi: Record<CartButtonDisplayStatus, CartButtonDisplayStatusUi> = {
  [CBDS_UNDECIDABLE]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.no_shipping_to_zip_code',
    notificationItem: {
      type: 'info',
      iconName: 'education-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.no_shipping_to_zip_code',
      },
    },
  }),
  [CBDS_UNAVAILABLE]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.product_out_of_stock',
    notificationItem: {
      type: 'warning',
      iconName: 'maintenence-16',
      text: {
        titleToken: 'aw.global.product_out_of_stock',
        subtitle: '',
      },
    },
  }),
  [CBDS_NOT_AVAILABLE_ONLINE]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.product_out_of_stock',
    notificationItem: {
      type: 'warning',
      iconName: 'maintenence-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.product_out_of_stock',
      },
    },
  }),
  [CBDS_NOT_AVAILABLE_ADULT_DELIVERY_MODE]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.product_not_available_adult_delivery_mode',
    notificationItem: {
      type: 'warning',
      iconName: 'maintenence-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.product_not_available_adult_delivery_mode',
      },
    },
  }),
  [CBDS_MODIFICATION_STRATEGY_DISALLOWS_CART_OPERATIONS]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.product_not_available_during_modification',
    notificationItem: {
      type: 'info',
      iconName: 'education-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.product_not_available_during_modification',
      },
    },
  }),
  [CBDS_NOT_AVAILABLE_DURING_ORDER_MODIFICATION]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.product_not_available_during_modification',
    notificationItem: {
      type: 'info',
      iconName: 'education-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.product_not_available_during_modification',
      },
    },
  }),
  [CBDS_NOT_AVAILABLE_OFFLINE_PRODUCT]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.offline_product',
    notificationItem: {
      type: 'info',
      iconName: 'education-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.offline_product',
      },
    },
  }),
  [CBDS_NOT_AVAILABLE_IN_COLD_PARCEL]: new CartButtonDisplayStatusUi({
    shortText: 'aw.global.prod_status_short.not_available_in_cold_parcel',
    shorterText: 'aw.global.prod_status_shorter.not_available_in_cold_parcel',
    notificationItem: {
      type: 'info',
      iconName: 'education-16',
      text: {
        title: '',
        subtitleToken: 'aw.global.not_available_in_cold_parcel',
      },
    },
  }),
};
